import type { PPProviderBehavior } from '../../lib/integrations/types';

interface CardDeviceMessageDeps {
	log: (text: string) => void;
	translate: (msg: string) => Promise<string>;
	show: (text: string) => void;
}

/**
 * Logs a card device message and shows it in the Card Payment info box, unless the
 * PP integration marks it as ignored (e.g. Fiserv's "PLEASE SIGN RECEIPT"). An ignored
 * message is still logged, and the info box keeps whatever it was showing.
 */
export async function handleCardDeviceMessage(
	ppBehavior: PPProviderBehavior,
	devName: string,
	msg: string,
	{ log, translate, show }: CardDeviceMessageDeps
): Promise<void> {
	const logText = `${ppBehavior.cardDeviceDisplayName} [${devName}]: ${msg}`;

	if (ppBehavior.isIgnoredCardDeviceMessage?.(msg)) {
		log(`${logText} (ignored, not displayed)`);
		return;
	}

	log(logText);
	show(await translate(msg));
}
